import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function Location() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1E3A5F] mb-4">오시는 길</h1>
          <p className="text-slate-500 text-lg">FMA수학학원 위치 및 교통 안내</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-start">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden border border-slate-100 h-[420px]">
            <iframe
              src="https://maps.google.com/maps?q=서울+강남구+대치동+933-29+동림빌딩&t=&z=17&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="FMA수학학원 위치"
            />
          </div>

          {/* Info */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <h2 className="text-lg font-bold text-[#1E3A5F] mb-5">위치 정보</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#2563EB]/10 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-line text-[#2563EB]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-700 mb-0.5">주소</p>
                    <p className="text-sm text-slate-500">서울특별시 강남구 대치동 933-29, 동림빌딩 302호</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#2563EB]/10 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-phone-line text-[#2563EB]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-700 mb-0.5">전화번호</p>
                    <a href="tel:010-2368-3385" className="text-sm text-[#2563EB] font-medium">
                      010-2368-3385
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#2563EB]/10 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-global-line text-[#2563EB]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-700 mb-0.5">블로그</p>
                    <a
                      href="https://blog.naver.com/fmasky"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#2563EB] font-medium"
                    >
                      blog.naver.com/fmasky
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-[#2563EB]/10 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-map-2-line text-[#2563EB]" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-700 mb-0.5">네이버 지도</p>
                    <a
                      href="https://map.naver.com/p/entry/place/831942435"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#2563EB] font-medium"
                    >
                      네이버 지도에서 보기
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <h2 className="text-lg font-bold text-[#1E3A5F] mb-5">운영 시간</h2>
              <div className="space-y-3">
                {[
                  { day: "월·화·수", time: "14:00 ~ 22:00" },
                  { day: "목·금", time: "휴원" },
                  { day: "토·일", time: "10:00 ~ 22:00" },
                ].map((item) => (
                  <div
                    key={item.day}
                    className="flex items-center justify-between py-2 border-b border-slate-50 last:border-0"
                  >
                    <span className="text-sm font-medium text-slate-700">{item.day}</span>
                    <span
                      className={`text-sm font-medium ${
                        item.time === "휴원" ? "text-red-400" : "text-[#2563EB]"
                      }`}
                    >
                      {item.time}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <h2 className="text-lg font-bold text-[#1E3A5F] mb-5">교통편 안내</h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <span className="shrink-0 text-xs font-bold bg-[#2563EB] text-white px-2 py-1 rounded-md">지하철</span>
                  <div className="text-sm text-slate-500 space-y-1">
                    <p>한티역 2번 출구 도보 5분 이내</p>
                    <p>대치역 2번 출구 도보 10분 이내</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="shrink-0 text-xs font-bold bg-emerald-500 text-white px-2 py-1 rounded-md">시내버스</span>
                  <p className="text-sm text-slate-500">333, 340, 420, 461, 4412, 2415, 4432, 147, 3422, 242, 472, 6411번 등</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="shrink-0 text-xs font-bold bg-orange-500 text-white px-2 py-1 rounded-md">마을버스</span>
                  <p className="text-sm text-slate-500">강남07</p>
                </div>
              </div>
            </div>

            <a
              href="tel:010-2368-3385"
              className="flex items-center justify-center gap-2 w-full h-12 bg-[#1E3A5F] hover:bg-[#2563EB] text-white font-bold rounded-xl text-sm transition-colors cursor-pointer"
            >
              <i className="ri-phone-line" />
              010-2368-3385 전화 상담
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
